import { VisitTrackingService } from '../services/url-shortener';
import type { http_VisitStatsResponse } from '../services/url-shortener';

export type VisitStatsResponse = http_VisitStatsResponse;

export const getVisitStats = (shortId: string): Promise<VisitStatsResponse> => {
  return VisitTrackingService.getVisitsStats(shortId);
};
